<template>
  <div class="yesnoonequestionmultilang">

    <label class="label">Scenario Name</label>
    <p class="control">
      <input v-model="scenario.name" class="input" type="text" placeholder="Enter Scenario Name">
    </p>

    <local-voice
      v-bind:locale.sync="scenario.parameters.locale"
      v-bind:vendor.sync="scenario.parameters.vendor"
      v-bind:voiceName.sync="scenario.parameters.voiceName"
    />


    <answer
      answer-title="Question"
      answer-theme="mainQuestion"
      v-bind:answer-audio-id.sync="scenario.parameters.mainQuestionId"
      v-bind:answer-audio.sync="scenario.parameters.mainQuestionAudio"
      v-bind:answer-text.sync="scenario.parameters.mainQuestionText"
      v-bind:answer-vendor.sync="scenario.parameters.vendor"
      v-bind:answer-locale.sync="scenario.parameters.locale"
      v-bind:answer-speaker.sync="scenario.parameters.voiceName"
      v-bind:answer-emotion.sync="scenario.parameters.mainEmotion"
      v-bind:answer-speed.sync="scenario.parameters.mainSpeed"
      v-bind:answer-generation-type.sync="scenario.parameters.mainQuestionAudioGenerationType"

      :is-saved=scenario.isSaved
      :client=scenario.client

      @generateAudioHandler="setMainAudio"
      @changeGenerationType="changeMainGenerationType"
    />

    <div class="second-layer positive-scenario">
      <div class = "label"><span class="title yesTitle">Сообщение при ответе да</span></div>
      <div class="wordsEditor" :class="wordsEditorClass(scenario.parameters.yesLocalizedVariants)">
        <vue-tags v-model="scenario.parameters.yesLocalizedVariants">
          <div class="tags-input tags are-large" slot-scope="{tag,removeTag,inputEventHandlers,inputBindings }">
              <span v-for="tag in scenario.parameters.yesLocalizedVariants" class="tags-input-tag tag is-large">
                    {{ tag }}
                    <button type="button" class="tags-input-remove delete" v-on:click="removeTag(tag)"/>
                  </span>
            <div class="control tags-input-text-div">
              <input class="tags-input-text input"  placeholder='добавте ответы "Да"' v-on="inputEventHandlers" v-bind="inputBindings"/>
            </div>
          </div>
        </vue-tags>
      </div>
      <answer
        answer-title=""
        answer-theme="yes"
        v-bind:answer-audio-id.sync="scenario.parameters.onYesId"
        v-bind:answer-audio.sync="scenario.parameters.onYesAudio"
        v-bind:answer-text.sync="scenario.parameters.onYesText"
        v-bind:answer-vendor.sync="scenario.parameters.vendor"
        v-bind:answer-locale.sync="scenario.parameters.locale"
        v-bind:answer-speaker.sync="scenario.parameters.voiceName"
        v-bind:answer-emotion.sync="scenario.parameters.onYesEmotion"
        v-bind:answer-speed.sync="scenario.parameters.onYesSpeed"
        v-bind:answer-generation-type.sync="scenario.parameters.onYesAudioGenerationType"

        :is-saved=scenario.isSaved
        :client=scenario.client

        @generateAudioHandler="setYesAudio"
        @changeGenerationType="changeYesGenerationType"
      />
      </div>

    <div class="second-layer negative-scenario">
      <div class = "label"><span class="title noTitle">Сообщение при ответе нет</span></div>
      <div class="wordsEditor" :class="wordsEditorClass(scenario.parameters.noLocalizedVariants)" >
        <vue-tags v-model="scenario.parameters.noLocalizedVariants">
          <div class="tags-input tags are-large" slot-scope="{tag,removeTag,inputEventHandlers,inputBindings }">
              <span v-for="tag in scenario.parameters.noLocalizedVariants" class="tags-input-tag tag is-large">
                    {{ tag }}
                    <button type="button" class="tags-input-remove delete" v-on:click="removeTag(tag)"/>
                  </span>
            <div class="control tags-input-text-div">
              <input class="tags-input-text input"  placeholder='добавте ответы "Нет"' v-on="inputEventHandlers" v-bind="inputBindings"/>
            </div>
          </div>
        </vue-tags>
      </div>
      <answer
        answer-title=""
        answer-theme="no"
        v-bind:answer-audio-id.sync="scenario.parameters.onNoId"
        v-bind:answer-audio.sync="scenario.parameters.onNoAudio"
        v-bind:answer-text.sync="scenario.parameters.onNoText"
        v-bind:answer-vendor.sync="scenario.parameters.vendor"
        v-bind:answer-locale.sync="scenario.parameters.locale"
        v-bind:answer-speaker.sync="scenario.parameters.voiceName"
        v-bind:answer-emotion.sync="scenario.parameters.onNoEmotion"
        v-bind:answer-speed.sync="scenario.parameters.onNoSpeed"
        v-bind:answer-generation-type.sync="scenario.parameters.onNoAudioGenerationType"

        :is-saved=scenario.isSaved
        :client=scenario.client

        @generateAudioHandler="setNoAudio"
        @changeGenerationType="changeNoGenerationType"
      />
    </div>


    <div>
      <scenario-bar
        :name="name"
        v-bind:is-saved=scenario.isSaved
        :is-ready=true
        v-bind:scenario="scenario"
        @set="setScenario"
      />
    </div>

  </div>
</template>

<script>
    import LocalVoice from '../commonComponents/LocalVoice'
    import Answer from '../Answer'
    import ScenarioCommon from '../commonComponents/ScenarioCommon'
    import ScenarioBar from './ScenarioSaver'
    import VueTags from 'vue-tags'
    export default {
      name: 'ScenarioQuestionYesNoMultiLang',
      components: {ScenarioBar, LocalVoice, Answer, VueTags},
      props: ['name', 'campaignid'],
      extends: ScenarioCommon,
      data() {
        return {
          scenario: {
            template: 'yesnoonequestionmultilang',
            parameters: {
              mainQuestionId: '',
              mainQuestionAudio: '',
              mainQuestionText: '',
              mainSpeed: 1,
              mainEmotion: 'neutral',
              mainQuestionAudioGenerationType: '',

              yesLocalizedVariants:[],
              onYesId: '',
              onYesAudio: '',
              onYesText: '',
              onYesSMSText: '',
              onYesSpeed: 1,
              onYesEmotion: 'neutral',
              onYesAudioGenerationType: '',

              noLocalizedVariants:[],
              onNoId: '',
              onNoAudio: '',
              onNoText: '',
              onNoSpeed: 1,
              onNoEmotion: 'neutral',
              onNoAudioGenerationType: '',


              locale: '',
              vendor: '',
              voiceName: ''
            },
            isSaved: false,
            isReady: true,
            checkDuration: true,
            name: ''
          }
        }
      },
      methods: {
        setScenarioExtend() {
          this.scenario.isReady = true
          this.scenario.checkDuration = true
        },
        setMainAudio(data) {
            this.scenario.parameters.mainQuestionAudio = data.url
        },
        setYesAudio(data) {
            this.scenario.parameters.onYesAudio = data.url
        },
        setNoAudio(data) {
            this.scenario.parameters.onNoAudio = data.url
        },
        changeMainGenerationType(type) {
          this.scenario.parameters.mainQuestionAudioGenerationType = type
        },
        changeYesGenerationType(type) {
          this.scenario.parameters.onYesAudioGenerationType = type
        },
        changeNoGenerationType(type) {
          this.scenario.parameters.onNoAudioGenerationType = type
        }
      }
    }
</script>

<style scoped>
  .tags-input-text.input {
    max-width: 170px;
  }
  .tag {
    background-color: unset;
  }
  .filled .tags-input-text-div {
    float: left;
  }
  .second-layer {
    margin-bottom: 16px;
    margin-top: 16px;
  }
  .wordsEditor {
    margin-bottom: 8px;
  }
  .wordsEditor.empty {
    height: 35px;
  }

  .tags-input-remove.delete {
    height: 14px;
    width: 14px;
    margin-top: -3px;
  }
  .yesTitle, .noTitle {
    font-size: 16px;
  }

  .tags-input-tag.tag {
    margin-top: -3px;
  }
</style>


<style>
 .yesnoonequestionmultilang .answer .add_parameter {
   display: none;
 }
 .yesnoonequestionmultilang .answer .generate_audio_control .speaker {
   display: none;
 }

 .yesnoonequestionmultilang .answer .generate_audio_control {
   display: inline-block;
 }
 .yesnoonequestionmultilang .answer .generate_audio_control .speed {
   display: inline-block;
 }
 .yesnoonequestionmultilang .answer .audio_single {
     display: inline-block;
 }

 .yesnoonequestionmultilang .answer .player-progress {
   width: 333px;
 }

 .yesnoonequestionmultilang .answer .tabs.is-boxed li.is-active a {
   background-color: unset;
 }
</style>



// WEBPACK FOOTER //
// 1_questionYesNo_i18.vue?5503aa36